
import { Markdown, TabBar, TabItem } from "@wot/components";
import { ILegal, ILegalType } from "@wot/typings";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import legalApi from "../../api/legal";
import { BACK_ARROW } from "../../assets/icons";

export default function Legal() {
  const { type } = useParams();
  const [activeTab, setActiveTab] = useState<ILegalType>("terms-conditions");
  const navigate = useNavigate();
  const [document, setDocument] = useState<ILegal>();

  const onTabChange = (newValue: string) => {
    navigate(`/legal/${newValue}`)
  }

  console.log(type);

  useEffect(() => {
    if (type) {
      // @ts-ignore
      setActiveTab(type);
      if (type === "terms-conditions") {
        legalApi.getDocuments("terms-conditions")
          .then((data) => {
            setDocument(data[0])
          }).catch(err => console.log(err))
      } else {
        legalApi.getDocuments("privacy-policy")
          .then((data) => {
            console.log(data);
            setDocument(data[0])

          }).catch(err => console.log(err))
      }
    }
  }, [type]);

  return (
    <div className="w-full flex flex-col">
      <div className="w-full md:w-[90%] mx-auto p-4 md:px-12 drop-shadow-md flex items-center">
        {/* <img src={WOT_LOGO} onClick={() => navigate("/")} className="h-10" /> */}
      </div>
      <div className="w-full md:w-[90%] h-full mx-auto px-4 md:px-12">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate(-1)}>
          <img src={BACK_ARROW} className="w-3 h-3" />
          <p className="text-sm underline">Back</p>
        </div>
      </div>
      <div className="w-full md:w-[90%] h-full mx-auto mt-5 px-4 md:px-12">
        <div className="my-7 text-base overflow-x-scroll">
          <TabBar
            value={activeTab}
            indicatorColor="text-secondary"
            onChange={onTabChange}
            textColor="text-black"
          >
            <TabItem fontSize={22} label="Terms Of Service" value="terms-conditions" />
            <TabItem fontSize={22} label="Privacy Policy" value="privacy-policy" />
          </TabBar>
        </div>

        <div className="w-full h-full flex flex-col my-4">
          <Markdown markdown={document?.mdText || ''} />
        </div>
      </div>
    </div>

  )
}